import http from '@/utils/http';
const post = async (action, data) => {
  const response = await http({ url: '/api/admin/v1/contractOrder/' + action, data, method: 'post' });
  if (response?.code !== 0) throw new Error(response?.msg || '项目核价请求失败');
  return response.data;
};
export const projectQuoteOptions = data => post('projectQuoteOptions', data);
export const projectQuote = data => post('projectQuote', data);
